import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import * as styles from './styles.css';

export interface IMapInfrastructureBalloonProps {
  timeWalk?: string;
  title: string;
  description?: string;
  type: string;
  iconBackgroundColor: string;
  dateText?: string;
}

export function MapInfrastructureBalloon(props: IMapInfrastructureBalloonProps) {
  const { description, timeWalk, title, type, iconBackgroundColor, dateText } = props;
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['balloon']}>
      <div className={styles['icon']} style={{ backgroundColor: iconBackgroundColor }}>
        <Icon color={'white_100'} />
      </div>
      <div className={styles['content']}>
        <UIText2>{title}</UIText2>
        {dateText && <UIText2 color={'gray60_100'}>{dateText}</UIText2>}
        {description && <UIText2 color={'gray60_100'}>{description}</UIText2>}
        {timeWalk && <UIText2 color={'gray60_100'}>{timeWalk}</UIText2>}
      </div>
    </div>
  );
}
